<template>
  <div>
    <div class="Examin_view">
      <div class="examin_mian">
        <div class="examin_head">
          <el-form
            :label-position="labelPosition"
            label-width="110px"
            :model="formLabelAlign"
            ref="formLabelAlign"
          >
            <el-form-item label="上传时间：" prop="region">
              <el-date-picker
                v-model="viewTime"
                @change="searchChang"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                :default-time="['00:00:00', '23:59:59']"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="课件名称：" prop="name">
              <el-input
                v-model.trim="formLabelAlign.name"
                placeholder="请输入课件名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="上传者：" prop="account">
              <el-input
                v-model.trim="formLabelAlign.account"
                placeholder="请输入上传者"
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="query_btn">
            <el-button
              type="primary"
              icon="el-icon-search"
              class="searchbtn"
              @click="searchData"
              >搜索</el-button
            >
            <el-button
              icon="el-icon-refresh"
              class="searchbtn sonbtn"
              v-if="$root.$hasbtn('重置')"
              @click="resetForm('formLabelAlign')"
              >重置</el-button
            >
          </div>
        </div>
        <div class="opratingbtn">
          <div class="button_view">
            <el-button
              size="small"
              v-if="$root.$hasbtn('上传课件')"
              @click="handleClick('kong')"
            >
              <i class="iconfont icon-daochu"></i>上传课件
            </el-button>
            <el-button @click="reqdeleteArr" v-if="$root.$hasbtn('批量删除')">
              <i class="iconfont icon-batch-shanchu"></i>批量删除
            </el-button>
          </div>
          <!-- 进度条 -->
          <div class="progress_view">
            <span>容量：</span>
            <el-progress
              :text-inside="true"
              :stroke-width="26"
              :percentage="PercentageOfCapacity"
              class="progress"
              :format="capacity(countFile)"
            ></el-progress>
          </div>
        </div>
        <!-- 表格 -->
        <div class="examinee_form" v-loading="loading">
          <el-table
            ref="tabledata"
            :data="getData"
            style="width: 100%"
            :row-class-name="tableRowClassName"
            @row-click="StepsListRowClick"
            @selection-change="handleSelectionChange"
            :row-key="getRowKeyOfTarget"
            :header-cell-style="{
              'background-color': '#8FCBFF',
              color: '#333333',
              height: '60px',
            }"
          >
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column type="index" label="序号" width="80">
            </el-table-column>
            <el-table-column
              v-for="(item, index) in formColumns"
              :key="index"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              height="150"
              label-height="50"
              align="center"
            >
              <template slot-scope="scope">
                <!-- <p v-if="index == 0">{{scope.row.UserID}}</p> -->
                <p v-if="index == 0">{{ scope.row.CoursewareName }}</p>
                <p v-if="index == 1">
                  {{ opentime(scope.row.BeginTime, scope.row.EndTime) }}
                </p>
                <p v-if="index == 2">
                  <el-button type="text" @click.stop="towebpdf(scope.row)"
                    >{{ scope.row.CoursewareName }}课件</el-button
                  >
                </p>
                <p v-if="index == 3">
                  {{ filesize(scope.row.Format, scope.row.FileSize) }}
                </p>
                <p v-if="index == 4">
                  {{ $moment(scope.row.CreateTime).format("YYYY/MM/DD HH:mm") }}
                </p>
                <p v-if="index == 5">{{ scope.row.RealName }}</p>
              </template>
            </el-table-column>
            <el-table-column
              prop="address"
              label="操作"
              align="center"
              width="220"
            >
              <template slot-scope="scope">
                <div class="operation_box">
                  <el-button
                    @click.stop="handleClick(scope.row)"
                    type="text"
                    v-if="$root.$hasbtn('编辑')"
                    size="small"
                    >编辑</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    v-if="$root.$hasbtn('详情')"
                    @click.stop="handleClick(scope.row, 'details')"
                    >详情</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    v-if="$root.$hasbtn('删除')"
                    @click.stop="deletelist(scope.row)"
                    >删除</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    @click.stop="stydySituation(scope.row)"
                    >学习情况</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <div class="foot_box">
          <div class="foot_pagetions">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="showpageindex"
              :page-size="pageSize"
              :page-sizes="pagesizesarr"
              layout="prev, pager, next,sizes, jumper"
              :total="total"
              class="pagination"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 删除验证弹窗 -->
    <div class="delete_view">
      <el-dialog
        title="温馨提示"
        :visible.sync="deleteStabe"
        :close-on-click-modal="false"
      >
        <div class="mian">
          <p v-if="deleteFang == 0">
            此操作将删除"{{ row.CoursewareName }}"该课件是否继续？
          </p>
          <p v-if="deleteFang == 1">此操作将删除已选视频,是否继续删除？</p>
          <p v-if="deleteFang == 2">请选择您需要删除的视频！</p>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="deleteStabe = false">取 消</el-button>
          <el-button
            type="primary"
            @click="reqdelete"
            v-if="deleteFang == 0"
            :loading="sundflag"
            >确 定</el-button
          >
          <el-button
            type="primary"
            @click="deletelistArr"
            :loading="sundflag"
            v-if="deleteFang == 1"
            >确 定</el-button
          >
          <el-button
            type="primary"
            @click="deleteStabe = false"
            :loading="sundflag"
            v-if="deleteFang == 2"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { BASEUrl } from "@/utils/request";
import resourcereq from "@/api/resources";
import systemclass from "@/api/systemclassification";
import loginvuex from "@/store/index";
import training from "@/api/trainingApi";

import qs from "qs";
export default {
  data() {
    return {
      stateArr: [], //存储开始时间和结束时间。
      value1: "", //时间
      loading: true,
      dialogVisibleObj: {
        addExamineeShow: true, // 添加考生
      },
      labelPosition: "right",
      formLabelAlign: {
        name: "", //视频名称
        account: "", //上传者
        examBeginDate: "", //时间
        examEndDate: "", // 结束时间
      },
      viewTime: "", // 时间查询v-model
      getDataCondition: {
        name: "", //视频名称
        account: "", //上传者
      },
      formExamin: {
        name: "",
      },
      showpageindex: 1, //显示的索引盒子
      getData: [],
      formColumns: [
        {
          prop: "CoursewareName",
          label: "课件名称",
          // width: "90px",
        },
        {
          prop: "UserName",
          label: "课件开放时间",
          // width: "90px",
        },
        {
          prop: "UserGroups",
          label: "课件预览",
          // width: "90px",
        },
        {
          prop: "DepartmentName",
          label: "格式大小",
          width: "100px",
        },
        {
          prop: "CreateTime",
          label: "上传时间",
          // width: "90px",
        },
        {
          prop: "RealName",
          label: "上传者",
          width: "70px",
        },
      ],
      sundflag: false, // 删除的防抖
      currentPage3: 1, //  当前页数
      pagesizesarr: [5, 10, 20, 50, 100],
      pageSize: 10,
      total: 100,
      rendersum: [],
      deleteFang: 0, // 0未单个删除
      deleteStabe: false, // 删除警告弹窗
      row: "", // 当前行信息
      countFile: "",
      allCountFile: "", //总容量
      multipleSelection: [], // 选中数据
      multipleSelectionIds: [],
      multipleSelectionCount: 0,
      totalCapacity: "",
    };
  },
  props: ["cutcoms"],
  methods: {
    // 搜索
    searchData() {
      this.Buriedpoint(
        {
          code: "Resource:Resources:search",
          parent_code: "Resource:Resources",
        },
        "statetime"
      );
      this.loading = true;
      this.formLabelAlign.pageIndex = 0;
      this.$refs.tabledata.clearSelection(); // 清除勾选状态
      if (this.formLabelAlign.name) {
        this.getDataCondition.name = this.formLabelAlign.name;
      } else {
        this.getDataCondition.name = "";
      }
      if (this.formLabelAlign.account) {
        this.getDataCondition.account = this.formLabelAlign.account;
      } else {
        this.getDataCondition.account = "";
      }
      this.getlist();
    },
    stydySituation(rowid) {
      this.$parent.videoid = rowid.CoursewareID;
      this.cutcoms(2);
    },
    // chang搜索
    searchChang() {
      this.loading = true;
      this.$refs.tabledata.clearSelection(); // 清除勾选状态
      if (this.viewTime == null) {
        this.formLabelAlign.examBeginDate = "";
        this.formLabelAlign.examEndDate = "";
      }
      this.getlist();
    },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 勾选当前行激活check
    StepsListRowClick(row, column, event) {
      this.$refs.tabledata.toggleRowSelection(row);
    },
    // 查询
    searchList() {
      this.currentPage3 = 1;
      this.getlist();
    },
    resetForm(formLabelAlign) {
      this.Buriedpoint(
        { code: "Resource:Resources:rest", parent_code: "Resource:Resources" },
        "statetime"
      );
      // 重置
      this.$refs[formLabelAlign].resetFields();
      this.$refs.tabledata.clearSelection(); // 清除勾选状态
      this.getDataCondition.name = "";
      this.getDataCondition.account = "";
      this.formLabelAlign.examBeginDate = "";
      this.formLabelAlign.examEndDate = "";
      this.viewTime = "";
      this.loading = true;
      this.showpageindex = 1;
      this.currentPage3 = 1;
      this.getlist();
    },
    // 给每一行设置key
    getRowKeyOfTarget(row) {
      return row.CoursewareID;
    },
    handleSelectionChange(val) {
      this.multipleSelectionIds = [];
      this.multipleSelection = val;
      this.multipleSelectionCount = 0;
      val.forEach((row) => {
        this.multipleSelectionIds.push(row.CoursewareID);
      });
      this.multipleSelection = val;
      this.multipleSelectionCount = this.multipleSelection.length;
    },
    //单个删除
    deletelist(row) {
      this.Buriedpoint(
        {
          code: "Resource:Resources:delete",
          parent_code: "Resource:Resources",
        },
        "statetime"
      );
      this.deleteFang = 0;
      this.row = row;
      this.deleteStabe = true;
    },
    async reqdelete() {
      // this.sundflag = true;
      let parmas = {
        CoursewareID: this.row.CoursewareID,
        FileName: this.row.FileName,
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        hid: JSON.parse(localStorage.getItem("userlist")).hid,
        _examID: "",
      };
      const data = await resourcereq.deleteCourseware(parmas);
      if (data.data.Status === 200) {
        this.deleteStabe = false;
        this.$message({
          message: "恭喜你，删除成功",
          type: "success",
        });
        setTimeout(() => {
          this.sundflag = false;
        }, 500);
        this.getlist();
      } else {
        this.sundflag = false;
      }
    },
    // 批量删除
    reqdeleteArr() {
      this.Buriedpoint(
        {
          code: "Resource:Resources:batchDelete",
          parent_code: "Resource:Resources",
        },
        "statetime"
      );
      if (this.multipleSelectionIds.length == 0) {
        this.deleteFang = 2; // 批量为空
      } else {
        this.deleteFang = 1; // 批量删除
      }
      this.deleteStabe = true;
    },
    async deletelistArr() {
      this.sundflag = true;
      let parmas = {
        CoursewareID: `[${this.multipleSelectionIds}]`,
        // filename: `${items.VideoName}.${items.Format}`,
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        hid: JSON.parse(localStorage.getItem("userlist")).hid,
        _examID: "",
      };
      const row = await resourcereq.deleteCoursewareArr(parmas);
      if (row.data.Status == 200) {
        this.deleteStabe = false;
        this.$message({
          message: "恭喜你，删除成功",
          type: "success",
        });
        setTimeout(() => {
          this.sundflag = false;
          this.getlist();
        }, 500);
      } else {
        this.sundflag = false;
      }
    },
    isNotSet() {
      this.getData.map((item) => {
        for (let ztiem in item) {
          if (item[ztiem] === "") {
            item[ztiem] = "未设置";
          }
        }
      });
    }, // 初始字段为空时状态
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.loading = true;
      this.getlist(); // 重新发起请求
    },
    handleCurrentChange(val) {
      this.currentPage3 = val;
      this.loading = true;

      this.getlist(); // 重新发起请求
      //   this.rendersum = this.pageData(this.currentPage3, 10, this.getData);
    },
    pageData: (number, pageSize, data) => {
      const pageList = [];
      const start = pageSize * number - pageSize;
      const end = pageSize * number;
      for (let i = start; i < end; i++) {
        pageList.push(data[i]);
      }
      const list = pageList.filter((item) => item);
      return list;
    },
    async towebpdf(item) {
      let link = document.createElement("a");
      link.style.display = "none";
      let urlid = item.FileName.split(".");
      let url = `http://khy.tibosi.com/html/fileManage/pdf/web/viewer.html?url=../courseware/${item.HospitalID}/${urlid[0]}.pdf`;
      if (item.isOld == 1) {
        let newname = item.FileName.replace(`.${item.Format}`, ".pdf");
        let parma = {
          name: newname,
          guid: JSON.parse(localStorage.getItem("userlist")).guid,
          userID: JSON.parse(localStorage.getItem("userlist")).userID,
          hid: JSON.parse(localStorage.getItem("userlist")).hid,
        };
        let resurl = await resourcereq.getVideoURL(parma);
        url = resurl.data.Data.url;
      }
      link.href = url;
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
      //释放URL对象所占资源
      window.URL.revokeObjectURL(url);
      //用完即删
      document.body.removeChild(link);
      this.dialogVisible = false;
    },
    handleClick(videoinfo, details) {
      if (videoinfo == "kong") {
        this.$parent.videoinfo = "kong";
        this.$parent.indexState = 0; // 增加
        localStorage.setItem("isreload", true);
        sessionStorage.setItem("examState", true); // 是否是考试进入 此状态表示是否有批量导入考生
        this.Buriedpoint({
          code: "Resource:Resources:upload",
          parent_code: "Resource:Resources",
        });
        this.$parent.cutcoms(1);
        this.$parent.details = "";
      } else if (details == "details") {
        this.$parent.details = "details";
        this.$parent.videoinfo = videoinfo;
        this.$parent.indexState = 2; // 详情
        localStorage.setItem("isreload", true);
        this.Buriedpoint({
          code: "Resource:Resources:detail",
          parent_code: "Resource:Resources",
        });
        this.$parent.cutcoms(1);
      } else {
        this.$parent.videoinfo = videoinfo;
        this.$parent.indexState = 1; // 编辑
        localStorage.setItem("isreload", true);
        sessionStorage.setItem("examState", true); // 是否是考试进入 此状态表示是否有批量导入考生
        this.Buriedpoint({
          code: "Resource:Resources:edit",
          parent_code: "Resource:Resources",
        });
        this.$parent.cutcoms(1);
        this.$parent.details = "";
      }
    },
    Buriedpoint(itemt, isstate) {
      if (isstate == "statetime") {
        //次数
        let parmas = {
          type: "2",
          code: itemt.code,
          parent_code: itemt.parent_code,
          stay_start_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_end_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_time: 1,
          ation_source: null,
          source: "khy",
          ip: null,
          userID: JSON.parse(loginvuex.state.userlist).userID,
          guid: JSON.parse(loginvuex.state.userlist).guid,
        };
        systemclass.addburied(parmas);
      } else {
        //闭环时间
        if (this.stateArr.length == 0) {
          this.stateArr[0] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
        } else {
          this.stateArr[1] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
          let statetime = this.$moment(new Date(this.stateArr[1])).diff(
            new Date(this.stateArr[0]),
            "seconds"
          );
          let parmas = {
            type: "2",
            code: itemt.code,
            parent_code: itemt.parent_code,
            stay_start_time: this.stateArr[0],
            stay_end_time: this.stateArr[1],
            stay_time: statetime,
            ation_source: null,
            source: "khy",
            ip: null,
            userID: JSON.parse(loginvuex.state.userlist).userID,
            guid: JSON.parse(loginvuex.state.userlist).guid,
          };
          systemclass.addburied(parmas);
          this.stateArr = [];
        }
      }
    },
    capacity(item) {
      return () => {
        if (item != "") {
          return (
            (item[0].countFile / 1024 / 1024).toFixed(1) +
            `M/${this.allCountFile}M`
          );
        }
      };
    },
    async getlist() {
      if (this.viewTime) {
        const time = JSON.parse(JSON.stringify(this.viewTime));
        this.formLabelAlign.examBeginDate = this.$moment(time[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.formLabelAlign.examEndDate = this.$moment(time[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      let params = {
        // VideoName: "", // 视频名称查询
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        url: "/api/courseware/VideoManage/getVideoList",
        UserID: JSON.parse(localStorage.getItem("userlist")).userID,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        pageIndex: this.currentPage3 - 1,
        pageCount: this.pageSize,
        userName: this.getDataCondition.account, //查询上传者
        CoursewareName: this.getDataCondition.name, // 视频名称查询
        createStartTime: this.formLabelAlign.examBeginDate, // 起始时间
        createEndTime: this.formLabelAlign.examEndDate, // 终止时间
        // userName: this.formLabelAlign.account, //查询上传者
        keyStr: ".show.bottom",
        hid: JSON.parse(localStorage.getItem("userlist")).hid,
        // createStartTime: this.formLabelAlign.examBeginDate, // 起始时间
        // createEndTime: this.formLabelAlign.examEndDate, // 终止时间
        _examID: "",
      };
      let res = await resourcereq.getCoursewareList(params);
      setTimeout(() => {
        this.loading = false;
      }, 500);
      this.getData = res.data.Data.result[0];
      this.countFile = res.data.Data.result[1];
      this.total = res.data.Data.result[2][0].count;
      this.allCountFile = res.data.Data.result[3][0].courseSize / 1024 / 1024;
      this.totalCapacity = res.data.Data.result[3][0].courseSize; // 总容量
      this.$parent.surplus = this.totalCapacity - this.countFile[0].countFile; // 计算出剩余可用容量
    },
    async init() {
      if (this.$route.query.trainId) {
        if (this.$route.query.state == 0) {
          // 去添加
          this.handleClick("kong");
        } else {
          // 编辑
          const obj = {
            scoreId: this.$route.query.scoreId,
            type: this.$route.query.type,
            typeId: this.$route.query.typeId,
          };
          const { data } = await training.getTypeDetail(obj);
          if (data.Status == 200) {
            if (this.$route.query.state === "xxqk") {
              // 去学习情况
              this.stydySituation(data.Data.coursInfo)
            } else {
              this.handleClick(data.Data.coursInfo);
              this.$parent.surplus =
                Number(data.Data.courseSize) - data.Data.countFile;
            }
          } else {
            this.$message.error(data.Data);
          }
        }
      }
    },
  },
  computed: {
    opentime() {
      return function (bigintime, endtime) {
        bigintime = this.$moment(bigintime).format("YYYY/MM/DD HH:mm");
        endtime = this.$moment(endtime).format("YYYY/MM/DD HH:mm");
        return bigintime + "-" + endtime;
      };
    },
    filesize() {
      return function (Format, size) {
        size = (size / (1024 * 1024)).toFixed(3);
        return Format + "/" + size + "M";
      };
    },
    PercentageOfCapacity() {
      if (this.countFile != "") {
        return (
          (
            this.countFile[0].countFile /
            1024 /
            1024 /
            this.allCountFile
          ).toFixed(2) * 100
        );
      }
      return 0;
    },
  },
  activated() {
    sessionStorage.removeItem("examState");
    this.isNotSet();
    this.getlist();
    this.init();
  },
  created() {
    this.stateArr = [];
    localStorage.removeItem("isreload");
  },
};
</script>

<style lang="scss" scoped>
.Examin_view {
  box-sizing: border-box;
  background-color: #ffffff;
  .title_box {
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  .examin_mian {
    box-sizing: border-box;
    background-color: #ffffff;
    width: 100%;
    height: 100%;
  }
  ::v-deep .dialog-footer {
    margin-bottom: 30px;
  }
  ::v-deep.el-dialog__footer {
    justify-content: center !important;
    margin-bottom: 50px;
  }
  .el-dialog__footer span > button {
    margin-top: 10px;
    width: 103px;
    height: 42px;
  }
  ::v-deep .el-dialog {
    width: 1593px;
    border-radius: 5px 5px 0px 0px;
  }

  .progress_view {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-right: 20px;
    > span {
      display: inline-block;
    }
    ::v-deep .el-progress {
      width: 400px;
    }
  }
  ::v-deep .el-dialog__header {
    padding: 0px 24px;
  }
  .examin_head {
    padding: 30px 24px 10px 30px;
    //  background-color: #64b5ff;
    display: flex;
    // justify-content: space-between;
    border-bottom: 1px solid rgba(231, 231, 231, 0.774);
    .el-form {
      display: flex;
    }
    .query_btn {
      display: flex;
      .el-button {
        width: 88px;
        height: 40px;
        margin-left: 24px;
      }
    }
  }
  .examinee_form {
    min-height: 480px;
    padding: 0px 20px 0px 34px;
  }
}

::v-deep .delete_view .el-dialog {
  width: 496px;
  height: 546px;
  border-radius: 5px 5px 0px 0px;
  .input_layout {
    display: flex;
  }
}
::v-deep .el-dialog__header {
  height: 55px;
  line-height: 55px;
  background: linear-gradient(180deg, #64b5ff 0%, rgba(199, 228, 255, 1) 100%);
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
::v-deep .el-dialog__footer {
  padding: 0;
  display: flex;
  justify-content: center;
  align-content: center;
  text-align: center;
  span > button {
    width: 60px;
    height: 32px;
    opacity: 1;
    border-radius: 4px;
    padding: 0px;
    margin-top: 38px;
    &:nth-child(2) {
      margin-left: 90px;
    }
  }
}
::v-deep .el-dialog__body {
  padding: 0;
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
// 分页
.foot_box {
  position: relative;
  height: 88px;
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
}
.operation_box {
  .el-button {
    font-size: 16px;
  }
}
.opratingbtn {
  display: flex;
  justify-content: space-between;
  .button_view {
    height: 70px;
    padding-left: 30px;
    display: flex;
    align-items: center;
    > :nth-child(1) {
      height: 40px;
      background-color: #64b5ff;
      color: #ffffff;
      border: #ffffff;
    }
    > :nth-child(2) {
      height: 40px;
      background-color: #e54d4d;
      color: #ffffff;
      border: #ffffff;
    }
  }
}
::v-deep .cell {
  text-align: center;
}
::v-deep.el-table th > .cell {
  text-align: center;
}
::v-deep .el-table-column--selection .cell {
  text-align: center;
}
::v-deep .el-table th:nth-child(1) {
  opacity: 1;
  border-radius: 4px 0px 0px 4px;
}
::v-deep .el-table th:nth-child(9) {
  opacity: 1;
  border-radius: 0px 4px 4px 0px;
}

::v-deep .el-form {
  div:nth-child(2),
  div:nth-child(3) {
    .el-form-item__label {
      width: 120px !important;
    }
    .el-form-item__content {
      margin-left: 120px !important;
    }
  }
}
::v-deep .el-table .cell {
  text-align: center;
}
::v-deep .delete_view .el-dialog {
  width: 320px;
  height: 260px;
  border-radius: 5px 5px 0px 0px;
  .input_layout {
    display: flex;
  }
  .el-dialog__body {
    padding: 24px 24px;
  }
  .mian {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
    p {
      // height: 60px;
      // line-height: 30px;
      // text-align: center;
      font-size: 16px;
    }
  }
  .dialog-footer {
    .el-button {
      width: 70px;
      height: 40px;
    }
  }
}
::v-deep .el-dialog__header {
  height: 55px;
  line-height: 24px;
  background: linear-gradient(180deg, #64b5ff 0%, rgba(199, 228, 255, 1) 100%);
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
::v-deep .el-dialog__footer {
  padding: 0;
  display: flex;
  justify-content: center;
  align-content: center;
  text-align: center;
  span > button {
    width: 60px;
    height: 32px;
    opacity: 1;
    border-radius: 4px;
    padding: 0px;
    margin-top: 38px;
    &:nth-child(2) {
      margin-left: 90px;
    }
  }
}
::v-deep .el-dialog__body {
  padding: 0;
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>